import type { PaginationParams } from "@dune/types";

export const tasksQueryKeys = {
	all: ["tasks"] as const,
	lists: () => [...tasksQueryKeys.all, "lists"] as const,
	list: (filters?: { status?: string; assigneeId?: number }) =>
		[...tasksQueryKeys.lists(), filters] as const,
	details: () => [...tasksQueryKeys.all, "details"] as const,
	detail: (taskId: number) => [...tasksQueryKeys.details(), taskId] as const,
	activeTasksList: () => [...tasksQueryKeys.all, "active"] as const,
	activeTasks: (params: PaginationParams) =>
		[...tasksQueryKeys.activeTasksList(), params] as const,
};
